import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default function useListActivitiesAllowed() {
	return useFeatureAvailable(Feature.ACTIVITIES_AND_APPOINTMENTS);
}
